import { render, staticRenderFns } from "./ArrivalInfo.vue?vue&type=template&id=3b1e8ed2&scoped=true"
import script from "./ArrivalInfo.vue?vue&type=script&lang=js"
export * from "./ArrivalInfo.vue?vue&type=script&lang=js"
import style0 from "./ArrivalInfo.vue?vue&type=style&index=0&id=3b1e8ed2&prod&scoped=true&lang=scss"
import style1 from "./ArrivalInfo.vue?vue&type=style&index=1&id=3b1e8ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e8ed2",
  null
  
)

export default component.exports